import { getBrand } from '@tme/toyota-common';

const addProtocol = /^\s*(https?:)?\/\//;
((): void => {
	window.T1 = window.T1 || {
		settings: {
			cpB2cAggrHost: `cpb2csa.toyota-europe.com`,
			ssoServiceUrl: `https://ssomsa.toyota-europe.com`,
			country: `gb`,
			language: `en`,
			brand: `TOYOTA`,
			ssoRecaptchaKey: ``
		}
	};
})();
export const CONSTANTS = {
	BRAND: getBrand(),
	API: {
		SERVICE: {
			AGGREGATOR:
				`https://` +
					window.T1.settings.cpB2cAggrHost.replace(addProtocol, ``) ||
				`cpb2csa.toyota-europe.com`
		},
		ENDPOINTS: {
			AGGREGATOR: {
				VINCHECKER_LABELS: `/api/aem/content/cp/ui-content/cp-vin-checker-ui-content`,
				MENU_LABELS: `/api/aem/content/cp/ui-content/cp-menu-ui-content`,
				VINCHECKER_UIO_URL: `/vehicle/vin/:vin/vinChecker`
			}
		}
	},
	HTTP_RESPONSE_CODES: {
		NO_CONTENT: 204,
		FORBIDDEN: 403,
		NOT_FOUND: 404,
		PRECONDITION_FAILED: 412,
		INTERNAL_SERVER_ERROR: 500,
		CONFLICT: 409,
		UNAUTHORIZED: 401,
		PROACE_ERROR: 400
	},
	HTTP_METHODS: {
		GET: `GET`,
		POST: `POST`,
		PUT: `PUT`,
		DELETE: `DELETE`
	},
	BREAKPOINTS: {
		MEDIUM: 768
	},
	CHARACTER_TO_REMOVE_POPOVERID: `/\\\\`,
	VEHICLE_DEFAULT_IMAGE_URL: `https://cp-common.toyota-europe.com/cp-client/images/svg/cp/ghost_vehicle_image.svg`,
	ORDER_OF_SERVICES: [
		`defaultService`,
		`standardServices`,
		`stellantisConnectedServices`,
		`remoteServices`,
		`digitalKeyServices`
	],
	HEADING_CLASS: getBrand() === `TOYOTA` ? `cp-h3` : `h3`
};
